type ClearCallback = () => void;

export class EmptyRowContext {
    public constructor(public clearAllFilters: ClearCallback) {
        this.$implicit = clearAllFilters;
    }

    public $implicit: ClearCallback;
}
